import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white" }

import { ref, watch, onMounted, nextTick } from 'vue'
import CommentComponent from '../atoms_molecules/Comment.vue'
import CommentCreation from '../atoms_molecules/CommentCreation.vue'
import Comment, { Commentable } from '../../../api/v2/models/comment'
import ConfirmDialog from '../atoms_molecules/ConfirmDialog.vue'
import CommentForm from '../../../api/v2/forms/comment'
import api from '../../../api/v2/api'
import User from '../../models/user'
import {makeChannel, removeChannel} from '../../../../action_cable/cable'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommentContainer',
  props: {
    commentable: {},
    user: { default: null }
  },
  setup(__props: any) {

const props = __props

const comments = ref<Comment[]>([])
const showCommentForm = ref(false)
const channel = ref<any>(null)
const confirm = ref<InstanceType<typeof ConfirmDialog> | null>(null)

const loadComments = async () => {
  comments.value = await api.comment.index(props.commentable.commentableId, props.commentable.commentableType)
}

const createComment = async (newComment: string) => {
  try {
    const commentForm = new CommentForm()
    commentForm.body = newComment
    commentForm.commentableId = props.commentable.commentableId
    commentForm.commentableType = props.commentable.commentableType
    await api.comment.create(commentForm)
    loadComments()
    showCommentForm.value = false
  } catch (e) {
  } finally {
  }
}

const deleteComment = async (commentId: number) => {
  try {
    if (await (confirm.value as any)?.open('本当によろしいですか？')) {
      await api.comment.delete(commentId)
      loadComments()
    }
  } catch (e) {
  } finally {
  }
}

const updateComment = async (comment: Comment) => {
  try {
    await api.comment.update(comment.id, { body: comment.body })
    comment.isEditing = false
    loadComments()
  } catch (e) {
  } finally {
  }
}

const createChannel = () => {
  removeChannel('LessonCommentChannel')

  channel.value = makeChannel(
    'LessonCommentChannel',
    async (e: any) => {
      await loadComments()
    },
    () => {
      channel.value.send({
        action: 'follow',
        data: {
          relativeable_id: props.commentable.commentableId,
          relativeable_type: props.commentable.commentableType
        }
      })
    },
  )
}

watch(() => props.commentable, () => {
  nextTick(() => {
    createChannel()
  })
})

onMounted(async () => {
  await loadComments()
  createChannel()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (comment) => {
        return (_openBlock(), _createBlock(CommentComponent, {
          key: comment.id,
          id: `comment-${comment.id}`,
          class: "px-0",
          comment: comment,
          user: __props.user,
          deleteComment: deleteComment,
          updateComment: updateComment
        }, null, 8 /* PROPS */, ["id", "comment", "user"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode(CommentCreation, {
      showCommentForm: showCommentForm.value,
      onCancel: ()=>showCommentForm.value = false,
      onOpen: ()=>showCommentForm.value = true,
      createComment: createComment
    }, null, 8 /* PROPS */, ["showCommentForm", "onCancel", "onOpen"]),
    _createVNode(ConfirmDialog, {
      ref_key: "confirm",
      ref: confirm
    }, null, 512 /* NEED_PATCH */)
  ]))
}
}

})